'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faRoute } from '@fortawesome/pro-solid-svg-icons';
import { useDrawer } from 'src/hooks/drawers/useDrawer';
import { ROUTES_DRAWER_ID } from '../../constants';

/**
 * RoutesDrawerToggle - Floating button to open the routes drawer
 *
 * This component should be rendered inside a map container with relative positioning.
 * It provides a single button to open the RoutesDrawer.
 */
const RoutesDrawerToggle: React.FC = () => {
  const { isDrawerOpen, openDrawer } = useDrawer();

  const isOpen = isDrawerOpen(ROUTES_DRAWER_ID);

  const handleOpen = () => {
    openDrawer(ROUTES_DRAWER_ID);
  };

  // Don't show when drawer is open
  if (isOpen) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow-[0px_8px_8px_0px_rgba(0,0,0,0.08)] border border-neutral-200 inline-flex flex-col overflow-hidden">
      <button
        onClick={handleOpen}
        aria-label="Open routes drawer"
        title="Routes"
        data-testid="routes-drawer-toggle-button"
        className="font-semibold transition-all duration-200 select-none text-base bg-neutral-50 text-neutral-700 hover:bg-neutral-100 active:bg-neutral-200 p-4 flex items-center justify-center rounded-none"
      >
        <Icon icon={faRoute} className="text-neutral-600 font-bold w-4 h-4" />
      </button>
    </div>
  );
};

export default RoutesDrawerToggle;
